export const feedbacksEng = [
  {
    id: 1,
    message:
      'An excellent course, meticulously structured down to every line of code. The mentor is highly dedicated, teaching from real-world experience, and even staying up late until midnight to fix bugs with students. This course is truly a turning point to step out of the comfort zone of model.fit and unlock your hidden engineering potential.',
    author: {
      username: 'Duong Nguyen',
      createAt: new Date(),
      company: 'FPT Smart Cloud',
      position: 'AI Engineer',
      experience: '2+ years',
      course: 'FSDS K1',
      avatar: '/images/nguyen_tran_dang_duong.jpeg',
    },
    repository: {
      href: 'https://github.com/duongngyn0510/continuous-deployment-to-gke-cluster',
      start: 91,
      fork: 18,
      name: 'Continuous deployment text image retrieval service to Google Kubernetes Engine using CI/CD',
      image: `bg-[url('/images/architecture/1-nguyen_tran_dang_duong.png')]`,
    },
  },
  {
    id: 2,
    message:
      'The course modules are well-structured and detailed, making it easy for learners to apply them in real-world scenarios. Anh Quan is always ready to answer any questions. Additionally, the course provides invaluable real-world insights that are hard to find elsewhere.',
    author: {
      username: 'Dung Hoang',
      createAt: new Date(),
      company: 'NamiTech JSC',
      position: 'AI Engineer',
      experience: '4+ years',
      course: 'FSDS K1',
      avatar: '/images/dung_hoang.jpeg',
    },
    repository: {
      href: 'https://github.com/dunghoang369/feature-store',
      start: 56,
      fork: 10,
      name: 'Building a Feature Store System',
      image: `bg-[url('/images/architecture/2-dung_hoang.png')]`,
    },
  },
  {
    id: 3,
    message:
      'In my personal opinion, this is one of the most essential courses for those interested in MLops but don’t know where to start. This course not only provides in-depth knowledge of Machine Learning Engineering but also equips students with valuable skills for both work and life. The instructor is genuinely enthusiastic and cares about each student. Moreover, if you perform well, the instructor might even recommend you to top companies! PS: You can also get career guidance, CV reviews, and even share personal concerns with Anh Wan. This course has given me more than I expected ❤️',
    author: {
      username: 'Tien Nguyen',
      createAt: new Date(),
      company: 'Momo',
      position: 'ML Engineer',
      experience: '2+ years',
      course: 'FSDS K1',
      avatar: '/images/tien_nguyen.jpeg',
    },
    repository: {
      href: 'https://github.com/TienNguyenKha/Diabetes-Prediction',
      start: 22,
      fork: 3,
      name: 'Building a Diabetes Prediction System',
      image: `bg-[url('/images/architecture/3-tien_nguyen.png')]`,
    },
  },
  {
    id: 4,
    message:
      'A great course that helps with deploying an ML system into production. The course is engineering-heavy but thoroughly explained. Highly recommend it to everyone!',
    author: {
      username: 'Viet Khoa',
      createAt: new Date(),
      company: 'UC Irvine',
      position: 'Master, Data Science',
      experience: '4+ years',
      course: 'FSDS K2',
      avatar: '/images/viet_khoa.jpeg',
    },
    repository: {
      href: 'https://github.com/eufouria/toxic-text-classification',
      start: 10,
      fork: 4,
      name: 'Build Toxic Text Classification App',
      image: `bg-[url('/images/architecture/4-viet_khoa.png')]`,
    },
  },
  {
    id: 5,
    message:
      'All three courses are super detailed and provide a solid foundation for stepping into the MLOps world. The instructor has deep expertise and is incredibly dedicated. Many thanks to boss Wan, the handsome guy!!!',
    author: {
      username: 'Long Pham',
      createAt: new Date(),
      company: 'Viettel',
      position: 'AI Engineer',
      experience: '2+ years',
      course: 'FSDS K2',
      avatar: '/images/pham_khac_long.jpeg',
    },
    repository: {
      href: 'https://github.com/longphamkhac/IQA',
      start: 31,
      fork: 1,
      name: 'Building an Image Quality Assessment System',
      image: `bg-[url('/images/architecture/5-pham_khac_long.png')]`,
    },
  },
]

export type FeedbackType = (typeof feedbacksEng)[0]
